import { RestApiProxy, SagasProxy } from 'com-gyf-webcore-servicehub';

let PerfilManager = function () {

    /**
     * Crea el perfil
     * @param {any} data
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function _createPerfil(data, sagasCallback, viewCallback) {
        let localValues = mapearPerfil(data);
        ejecutarSagas(localValues, 'SAGA_NUEVO_PERFIL', sagasCallback, viewCallback);
    }

    /**
     * Elimina el perfil
     * @param {any} data
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function _deletePerfil(data, sagasCallback, viewCallback) {
        let localValues = mapearPerfilDelete(data);
        ejecutarSagas(localValues, 'SAGA_ELIMINAR_PERFIL', sagasCallback, viewCallback);
    }

    /**
     * Edita el perfil
     * @param {any} data
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function _editPerfil(data, sagasCallback, viewCallback) {
        let localValues = mapearPerfilEdit(data);
        ejecutarSagas(localValues, 'SAGA_EDITAR_PERFIL', sagasCallback, viewCallback);
    }

    /**
     * Mapea perfil a crear
     * @param {any} data
     */
    function mapearPerfil(data) {
        let localValues = {
            "PERFIL": {
                'CODIGO': data.CODIGO,
                'DESCRIPCION': data.DESCRIPCION,
                'ProductoId': data.PRODUCTO_ID != 0 ? data.PRODUCTO_ID : null,

                'Funcionalidad': data.FUNCIONALIDAD,
                'GruposWindows': data.GRUPOS_WINDOWS.map((g) => { return { GrupoWindows: g.Descripcion } })
            }
        }

        return localValues;
    }

    /**
     * Mapea perfil a eliminar
     * @param {any} data
     */
    function mapearPerfilDelete(data) {
        let localValues = {
            'PROFILE_ID': data.id
        }

        return localValues;
    }

    /**
     * Mapea perfil a editar
     * @param {any} data
     */
    function mapearPerfilEdit(data) {
        let localValues = {
            "PERFIL": {
                'ID': data.ID,
                'CODIGO': data.CODIGO,
                'DESCRIPCION': data.DESCRIPCION,
                'ProductoId': data.PRODUCTO_ID != 0 ? data.PRODUCTO_ID : null,
                'GruposWindows': data.GRUPOS_WINDOWS.map((g) => { return { GrupoWindows: g.Descripcion } })
            },
            'PROFILE_ID': data.ID 
        }

        return localValues;
    }

    /**
     * Ejecuta sagas segun parámetro "saga"
     * @param {any} localValues
     * @param {any} saga
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function ejecutarSagas(localValues, saga, sagasCallback, viewCallback) {
        SagasProxy.AddSagaRequests(localValues, saga, "CONCIERGE", "SEGURIDAD");

        RestApiProxy.SetApiUrl();

        SagasProxy.Execute(sagasCallback, undefined, viewCallback, null, null, "SEGURIDAD");
    }

    return {
        CreatePerfil: function (data, sagasCallback, viewCallback) {
            return _createPerfil(data, sagasCallback, viewCallback);
        },
        DeletePerfil: function (data, sagasCallback, viewCallback) {
            return _deletePerfil(data, sagasCallback, viewCallback);
        },
        EditPerfil: function (data, sagasCallback, viewCallback) {
            return _editPerfil(data, sagasCallback, viewCallback);
        }
    }
};

let perfilManager = new PerfilManager();
export default perfilManager;